exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home {\n\tbackground-color: #222;\n\tbackground-size: cover;\n\tpadding: 0;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n\nh1 {\n  font-size: 60px;\n\tline-height: 80px;\n\tmargin-bottom: 16px;\n\tcolor: #3CB371;\n  text-transform: capitalize;\n}\n\nh2 {\n\tline-height: 80px;\n\tmargin-bottom: 16px;\n\tcolor: #3CB371;\n}\n\nh2 a {\n  color: #3CB371\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/vsts/work/1/s/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = 1